import React from "react"

import "./skills.css"

const Skills = () => {
    const skills = [
        '.net (framework)',
        '.net (core)',
        'JavaScript',
        'node',
        'MSSQL',
        'Azure',
        'Terraform',
        'CI/CD',
        'Angular',
        'React',
    ]

    return (
        <div className="skills-container">
            {skills.map(s => (
                <div className="skill" key={s}>{s}</div>
            ))}
        </div>
    )
}

export default Skills
